/**
 * Checks if taxes fetch should show error based on deal type and rates
 * @param {Object} rates - Detail rates from API response
 * @param activeTab
 * @param obfuscatedCredit
 * @returns {boolean} Whether to show taxes fetch error
 */
const checkTaxesFetchError = (rates, activeTab, obfuscatedCredit) => {
  if (activeTab === 'cash') {
    return rates?.[obfuscatedCredit]?.nationalOffers && !rates?.[obfuscatedCredit]?.cashOffers;
  }
  return rates?.[obfuscatedCredit]?.nationalOffers;
};
export { checkTaxesFetchError as default };
